export default __webpack_public_path__ + "static/media/6.4784a480.jpg";